import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRegion = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	stroke: "currentColor",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.45 12.45L8.4 14.25L7.5 17.4L8.4 20.1M16.5 19.65L16.05 17.4L13.8 16.5V13.35L16.5 12.45L20.55 12.9M18.3 6.15L17.85 7.5L14.7 7.95V10.65L16.95 9.75H18.75L20.55 10.65M3.45 10.65L5.7 8.85L7.95 8.4L9.75 5.7L8.85 3.9M12 21C16.9705 21 21 16.9705 21 12C21 7.02943 16.9705 3 12 3C7.02943 3 3 7.02943 3 12C3 16.9705 7.02943 21 12 21Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRegion;
